import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";
import { ToasterService } from '../../_services/toaster.service';

declare var $: any;

@Component({
  selector: 'app-planlist',
  templateUrl: './planlist.component.html',
  styleUrls: ['./planlist.component.css']
})
export class PlanlistComponent implements OnInit {

  userdetaild: string;
  returnUrl: string;
  promoCodeList: any[] = [];

  constructor(private authenicationService: AuthenicationService, private router: Router, private route: ActivatedRoute,private toaster: ToasterService, private pricesService: PricesService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.getPlanList();

  }

  getPlanList() {
    this.pricesService.getPlanList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.promoCodeList = data.promoCodeList;
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);

          } else {
            this.toaster.showError('Plan', data.ResponseMessage);
            setTimeout( () => {
              $(function () {
                $('#example').DataTable();
              });
            }, 1000);
          }
        },
        error => {
          this.toaster.showError('Plan', error);
          setTimeout( () => {
            $(function () {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }

  deletePlan(id, is_active) {
    if(confirm(`Are you sure to ${is_active ? "Activate" : "Delete"}`)) {
    this.pricesService.deleteandundeletePlan({plan:id, is_active: is_active})
      .subscribe(
        (data: any) => {
          console.log(data)
          if (data && data.ResponseCode === '200') {
            this.getPlanList();
            this.toaster.showSuccess('Plan', data.ResponseMessage);
          } else {
            this.toaster.showError('Plan', data.ResponseMessage);
          }
        },
        error => {
          this.toaster.showError('promoCodeList', error.error.ResponseMessage);
        });
      }
  }


}
